import Profile from "./pages/Profile/Profile";
import ResponsiveDrawer from "./pages/layout";
import WelcomePage from "./pages/home";
import LearningCenter from "./pages/Learning/LearningCenter";
import FAQCommon from "./pages/faq";
import NewCommonSessions from "./pages/Coaching/NewCommonSessions";
import TasksNew from './pages/Tasks/TasksNew';

export const routes = [
  {
    path: '/',
    exact: true,
    layout: ResponsiveDrawer,
    component: WelcomePage
  },
  {
    path: '/profile',
    exact: true,
    layout: ResponsiveDrawer,
    component: Profile
  },
  {
    path: '/sessions',
    exact: true,
    layout: ResponsiveDrawer,
    component: NewCommonSessions
  },
  {
    path: '/resources',
    exact: true,
    layout: ResponsiveDrawer,
    component: LearningCenter
  },
  {
    path: '/tasks',
    exact: true,
    layout: ResponsiveDrawer,
    component: TasksNew
  },
  {
    path: '/faq',
    exact: true,
    layout: ResponsiveDrawer,
    component: FAQCommon
  }
];